import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

export async function updateScript(
  params: UpdateScriptService.Params,
  data: UpdateScriptService.Payload,
): Promise<UpdateScriptService.Response> {
  const body = {
    texto: data.text,
    ordem: data.order,
  };

  const response = await httpClient.put<IScriptDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/blocos/${params.blockId}`,
    body,
  );

  return ScriptMapper.toPresentation(response);
}

export namespace UpdateScriptService {
  export interface Params {
    blockId: number;
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export interface Payload {
    text: string;
    order: number;
  }
  export type Response = IScript;
}
